/* eslint-disable */
import JsZip from 'jszip';
// import jsZipUtils from 'jszip-utils';
import saveAs from 'file-saver';
import _ from 'lodash';
function loadXHR (url) {
  return new Promise((resolve, reject) => {
    try {
      let xhr = new XMLHttpRequest();
      xhr.open('GET', url);
      xhr.setRequestHeader('cache-control', 'no-cache');
      xhr.responseType = 'blob';
      xhr.onerror = function () { reject('Network error.'); };
      xhr.onload = function () {
        if (xhr.status === 200) { resolve(xhr.response); } else { reject('Loading error:' + xhr.statusText); }
      };
      xhr.send();
    } catch (err) { reject(err.message); }
  });
}
function downLoadZip (images, filename=images.zip) {
  console.log(images);
  let zip = new JsZip();
  let count = 0;
  let zipFileName = filename;
  return new Promise((resolve, reject) => {
    images.forEach(async (url, idx) => {
      let filename = _.last(url.split('/')) + '.jpg';
      // let filename = url.split('/').splice(-1);
      try {
        let blob = await loadXHR(url)
        zip.file(filename, blob, {binary: true});
        count++;
        if (count === images.length) {
          const content = await zip.generateAsync({
            type: 'blob'
          })
          saveAs(content, zipFileName);
          return resolve(true)
        }
      } catch(e) {
        return reject(new Error(e))
      }
    })
  })
}
export default downLoadZip;
